module.exports = __webpack_public_path__ + "static/fonts/manrope-semibold.04cdef3f.woff";